import React, { useState, useEffect } from 'react';
import PageHeader from '../../../components/common/PageHeader/PageHeader';
import LargeDetailBox from '../../../components/common/DetailBox/LargeDetailBox';
import ErrorNotification from '../../../components/common/AlertBox/ErrorNotification';
import { useNavigate, useParams } from 'react-router-dom';
import '../../../components/common/CommonText.css';
import './PlanFeatures.css';
import { fetchFeatureById } from '../../../services/planfeatures/Featuresapi';

const FeaturesDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [feature, setFeature] = useState(null);
    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const load = async () => {
            const { data, error } = await fetchFeatureById(id);
            if (error === 1001) {
                navigate('/permission-denied');
            } else if (error) {
                setErrors({ general: 'Failed to load feature details.' });
            } else {
                setFeature(data);
            }
            setLoading(false);
        };
        if (id) load();
    }, [id]);

    if (loading) return <div className="whole-container"><p className="common-text fts-14 ftw-4">Loading...</p></div>;
    if (!feature) return <div className="whole-container"><p className="common-text fts-14 ftw-4">Feature not found.</p></div>;

    return (
        <div className="whole-container">
            <div className="top-heading">
                <PageHeader
                    pageName="Plans / Features /"
                    nestedpageName="Detail"
                    linkTo="/features"
                />
            </div>

            <div className="page-container">
                <ErrorNotification errors={errors} marginBottom="16px" />

                <div className="card">
                    <div className="card-header">
                        <span className="card-title">Feature Details</span>

                        {feature.is_system ? (
                            <button
                                className="popup-add-button common-text white fts-15 ftw-5 disabled-actions"
                                disabled
                            >
                                Edit Feature
                            </button>
                        ) : (
                            <button
                                className="popup-add-button common-text white fts-15 ftw-5"
                                onClick={() => navigate(`/features/edit/${feature.id}`)}
                            >
                                Edit Feature
                            </button>
                        )}
                    </div>

                    <div className="card-body">
                        <LargeDetailBox label="Feature Name" value={feature.name} />
                        <LargeDetailBox label="Description" value={feature.description} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeaturesDetail;